(function ($) {
  const sizeMaps = {
    'eu_to_us': {
      '35': '4', '35.5': '5', '36': '5.5', '37': '6', '37.5': '6.5', '38': '7',
      '38.5': '7.5', '39': '8', '39.5': '8.5', '40': '9', '41': '10', '42': '11',
      '43': '12', '44': '12.5', '45': '13', '46': '14',
    },
    'us_to_eu': {
      '4': '35', '5': '35.5', '5.5': '36', '6': '37', '6.5': '37.5', '7': '38',
      '7.5': '38.5', '8': '39', '8.5': '39.5', '9': '40', '10': '41', '11': '42',
      '12': '43', '12.5': '44', '13': '45', '14': '46',
    },
    'uk': {
      '35': '2', '35.5': '2.5', '36': '3', '36.5': '3.5', '37': '4', '37.5': '4.5',
      '38': '5', '38.5': '5.5', '39': '6', '40': '6.5', '41': '7', '41.5': '7.5',
      '42': '8', '42.5': '8.5', '43': '9', '44': '9.5', '45': '10', '46': '11',
    },
  };

  function renderSizeSelection($select) {
    const $form = $select.closest('form');
    const currentSystem = $form.find('.toggle-size.active').data('system') || 'eu';

    let $container = $select.next('.ws-size-selection');
    if ($container.length === 0) {
      $container = $('<div class="ws-size-selection">').insertAfter($select);
    }

    $container.empty();

    $select.find('option').each(function () {
      const $option = $(this);
      if ($option.val() === '') return;

      const val = $option.val();
      let text = $option.text();

      const normalizedText = text.replace(',', '.');
      const isUSSite = ($('body').hasClass('site-wolky-com') || window.location.hostname.includes('wolky.com'));

      if (isUSSite) {
        if (currentSystem === 'eu' && sizeMaps['us_to_eu'][normalizedText]) {
          text = sizeMaps['us_to_eu'][normalizedText];
        }
      } else {
        if (currentSystem === 'us' && sizeMaps['eu_to_us'][normalizedText]) {
          text = sizeMaps['eu_to_us'][normalizedText];
        } else if (currentSystem === 'uk' && sizeMaps['uk'][normalizedText]) {
          text = sizeMaps['uk'][normalizedText];
        }
      }

      const $div = $(`<div class="ws-size-selection-option" data-value="${val}">${text}</div>`);

      if ($option.is(':disabled')) $div.addClass('disabled');
      if ($option.is(':selected')) $div.addClass('selected');

      $container.append($div);
    });
  }

  $(document).on('click', '.ws-size-selection-option', function (e) {
    e.preventDefault();
    if ($(this).hasClass('disabled')) return;

    const $this = $(this);
    const value = $this.data('value');
    const $container = $this.closest('.ws-size-selection');
    const $select = $container.prev('select');

    $select.val(value).trigger('change');
    $select.closest('form').trigger('check_variations');
  });

  $(document).on('click', '.toggle-size', function (e) {
    e.preventDefault();
    const $this = $(this);
    const $form = $this.closest('form');

    $form.find('.toggle-size').removeClass('active');
    $this.addClass('active');

    renderSizeSelection($form.find('.wolkyshop_sizes_dropdown'));
  });

  $.fn.wsSizeSelection = function (options) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'resize':
          return this.each(function () {
            if (typeof this.resizeMenu === 'function') {
                this.resizeMenu();
            }
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }

    return this.each(function () {
      const $select = $(this);
      if ($select.data('ws-size-selection')) return;
      $select.data('ws-size-selection', true);

      renderSizeSelection($select);
    });
  };

  $(document).on('woocommerce_update_variation_values', function () {
    $('.wolkyshop_sizes_dropdown').each(function () {
      renderSizeSelection($(this));
    });
  });
})(jQuery);
